import React, { Component } from "react";
import Highcharts from "highcharts/highcharts.js";
import HighchartsReact from "highcharts-react-official";
import "./StackedBarChart.css"

const plotLabelFormatter = (value) => {
    if (value == 0) {
        return "-"
    }
    return `$${Math.abs(value) > 999 ? `${Math.round((Math.abs(value)/1000).toFixed(1))}K` : Math.round(value)}`
}

const defaultOptions = {
    title: null,
    legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        x: 40,
        y: -20,
        floating: false,
        itemDistance:40,
        itemHoverStyle: null,
        squareSymbol: true,
        margin: 40,
        itemStyle: {"color": "#fff", "font": "normal normal normal 16px/27px Arial", "textOverflow": "ellipsis"
}
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        bar: {
            dataLabels: {
                enabled: true,
                color: "#fff",
                style: {
                    fontSize: "16px",
                    font: "Arial",
                    borderRadius: "0px",
                },
                formatter: function() {
                    return plotLabelFormatter(this.point.individualIncome)
                }
            },
        },
        series: {
            animation: false,
            dataLabels: {
                enabled: true,
            },
            groupPadding: 0.15,
            pointWidth: 20,
            pointPadding: 1,
        },
    },
    tooltip: {
        borderRadius: 15,
        borderWidth: 1,
        borderColor: "#707070",
        backgroundColor: "#FFFFFF",
        padding: 17,
        shape: "square",
        style : {
            font: "Arial",
            fontSize: 14,
            color: "#333333",
            lineHeight: 25
        },
        formatter(){
            let response = `Education Attainment: <b>${this.series.name}</b><br/>`
            response += `Race/Ethnicity group: <b>${this.key}</b><br/>`
            response += `Median Individual Income: <b>${plotLabelFormatter(this.point.individualIncome)}</b><br/>`
            response += `% of Race/Ethnicity group: <b>${this.point.y}%</b><br/>`
            // response += `Total Individuals (weighted): <b>${this.point.weight.toLocaleString("en-US")}</b><br/>`
            return response
        }
    },
    exporting: { enabled: false }
}

class StackedBarChart extends Component {
  	constructor(props) {
		super(props);
  	}

	render() {
        Highcharts.setOptions(this.props.containerId, {});
        let newDefaultOptions = {...defaultOptions}
        if (this.props.stacking !== null) {
            newDefaultOptions.plotOptions.series = {"stacking": this.props.stacking, animation: false}
        }
        return (
            <div id={this.props.containerId}>
                {this.props.remainingOptions ? <HighchartsReact
                    options = {{
                        ...newDefaultOptions,
                        ...this.props.remainingOptions,
                    }}
                    highcharts = { Highcharts }
                /> : <h1>...loading...</h1>}
            </div>
        )
	}
}


export default StackedBarChart;
